import {
    DiscoveryCard,
    IDiscoveryCardProperties,
} from '@vfde-brix/ws10/discovery-card';
import { Customer } from '@vfde-sails/login';
import {
    getCMSConfig,
    getLoginCtaCmsProps,
} from '../cms';
import { DiscoveryCardLoginButtonConfig } from '../../interface';
import { isNotNullOrUndefined } from '../typeGuard';

const getLoginButtonByLoginStatus = (cmsConfig: DiscoveryCardLoginButtonConfig, customer?: Customer) => !customer
    ? getLoginCtaCmsProps(cmsConfig.unlogged)
    : customer.hasDslContract
        ? cmsConfig.dsl
        : cmsConfig.cableOrMobile;

/**
 * Returns the updated Discovery Card business based on the customer status
 */
export const getUpdatedDiscoveryCardBusiness = (
    comp: DiscoveryCard,
    customer?: Customer,
): Partial<IDiscoveryCardProperties> => {
    const props = comp.getProperties();

    for (const [index, config] of Object.values(getCMSConfig().discoveryCard).entries()) {
        const cmsConfigs = [
            getLoginButtonByLoginStatus(config.loginButton, customer),
            config.moreInfoButton,
        ].filter(isNotNullOrUndefined);

        for (const [buttonIndex, cmsConfig] of cmsConfigs.entries()) {
            const { buttonLinkItems } = props.discoveryCardItems[index] ?? [];

            if (!buttonLinkItems) {
                continue;
            }

            buttonLinkItems[buttonIndex].stdLabel = cmsConfig.text;
            buttonLinkItems[buttonIndex].linkHref = cmsConfig.link;
        }
    }

    return props;
};
